module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('h1', {
    staticClass: "calibre29",
    attrs: {
      "id": "calibre_pb_20"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "_Toc29478521"
    }
  }, [_c('span', {
    staticClass: "calibre30"
  }, [_vm._v("Chapter Four")]), _c('br', {
    staticClass: "calibre31"
  }), _c('span', {
    staticClass: "calibre32"
  }, [_vm._v("Messengers of the Gods")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The excitement of being in a foreign country to meet a complete stranger was all consuming. After landing in Japan, Rebecca was only able to relax when she envisioned Akio caring for her bookstore.")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("He was such a gentle and easy-going soul. She could picture him sitting in a large over-stuffed chair, tea and reading material beside him, enjoying an atmosphere of calm and civility. The bookstore was always such a peaceful and contemplative place. Deep down, Rebecca hoped that her dear friend")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("was not bored. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca strolled")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("through Nara along the covered sidewalks that protected her from the late autumn drizzle. If she were to meet someone, logically it would be in an obvious location. So, Rebecca headed to where all tourists congregated, where twelve hundred wild deer or ‘Messengers of the Gods’ regularly meandered down from the surrounding hills and freely roamed the streets of the small, bustling city. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Her destination was surprisingly quiet when, as if on cue, busloads of school children arrived. Classmates giggled and laughter peeled through the chilly air as Rebecca watched the worshipped and the faithful fuse into a swirling mixture of antlers and school uniforms. Vendors sat chain-smoking, selling special deer treats to the students while Gods lined up to devour the morsels from outstretched hands. With disbelief,")]), _c('span', {
    staticClass: "calibre35"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("she watched as school children bowed to the deer and shockingly the Gods, displaying a Pavlovian response from generations of free food, bowed back.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca cautiously avoided pointed antlers and the even more dangerous darting, giggling children. Unlike The Seeker, who blended into the shadows while watching the comings and goings of the Shinjuku Train Station, Rebecca dressed flamboyantly, her tall, lithe figure, pale skin and long blond tresses distinct in a crowd of jet-black hair. The printout of the email that had inspired this trip was still clasped in her tightly balled fist.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca bought some of the cookies and shared with the ‘Gods.’ While feeding a small, delicate fawn,")]), _c('span', {
    staticClass: "calibre36"
  }, [_vm._v(" she ")]), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("sensed someone staring.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("On a ridge near the park entrance, a tall stranger observed the riotous scene. Even from a distance, his height made him stand out. He had a muscular build, wide shoulders and thin waist. His black hair fell straight halfway down his back and he had piercing eyes that searched -- as did")]), _c('span', {
    staticClass: "calibre35"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca’s. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("He watched her coldly like an animal studying its prey, but then suddenly he smiled, his teeth white as pearls. For some reason, this unnerved her even more. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("He bowed deeply to the Buddhist monk standing beside him; the two men exchanged words")]), _c('span', {
    staticClass: "calibre35"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("and then bowed again. Alone, the stranger slowly approached Rebecca. His persona was regal, as if from another time and place. As he neared, she decided that he was an old soul in a young man’s body. Rebecca found the contrast very appealing. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("He bowed and with a gentle voice said, “We don’t have much time. Thank you for coming and please accept my apology if I speak directly.” Rebecca was unsettled, an uncommon feeling for her.  “My name is Alexander.” In an attempt to mask her attraction, Rebecca mentioned the coincidence between his name and her grandmother’s bookstore in Alexandria. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Alexander smiled poignantly, but ignored the comparison and continued, “I am here for the same reason as you. We both know that the world is about to experience a loss of catastrophic significance.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Her mind struggled to reconcile how he could possibly know, when one of the Messengers of the Gods suddenly bumped her and she jostled against the stranger’s muscular chest. For a moment, he held her and she found herself blushing -- something most rare. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("He chuckled. “Seems like the Gods have ordained that we be together.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("She gazed into his gray eyes flecked with yellow and recognized the eyes of a wolf. They expressed dignity and power as well as great loss. Without even realizing it, she muttered, “Apparently.”  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Alexander startled and released her. Rebecca hid a smile. He was vulnerable -- good -- she liked her supermen flawed.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre25"
  }, [_c('span', {
    staticClass: "calibre16",
    attrs: {
      "id": "calibre_pb_21"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-072085e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0000_split_007.vue
// module id = 81
// module chunks = 0